export default __webpack_public_path__ + "static/media/targets.e94a8356.png";